import { useState, useEffect } from 'react';

interface PriceConversion {
  rate: number;
  loading: boolean;
  error: string | null;
}

const TAUX_SECOURS = 0.92;
const API_URL = 'https://currency-cryptonvx.currency-api.workers.dev/v1/exchange?from=USD&to=EUR';
const TIMEOUT_MS = 50000;

export const usePriceConversion = (): PriceConversion => {
  const [rate, setRate] = useState<number>(TAUX_SECOURS);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const fetchRate = async () => {
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), TIMEOUT_MS);

        const response = await fetch(API_URL, { signal: controller.signal });

        clearTimeout(timeoutId);

        if (!response.ok) {
          console.warn('Erreur lors de la récupération du taux USD/EUR, utilisation du taux de secours');
          if (isMounted) setRate(TAUX_SECOURS);
          return;
        }

        const data = await response.json();
        const taux = (data && data.rates && data.rates.EUR) ? data.rates.EUR : TAUX_SECOURS;
        if (isMounted) setRate(taux);

      } catch (err) {
        console.warn('Erreur lors de la récupération du taux USD/EUR:', err);
        if (isMounted) {
          setError(err instanceof Error ? err.message : 'Une erreur est survenue');
          setRate(TAUX_SECOURS);
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchRate();

    return () => {
      isMounted = false;
    };
  }, []);

  return { rate, loading, error };
};

// Conserve la signature pour compatibilité
export const convertUSDtoEUR = (usdAmount: number, rate: number): number => {
  return usdAmount * rate;
};